export const getTitle = title => {
  if (!title) {
    return '';
  }

  if (typeof title.long === 'string') {
    return title.long;
  }

  return title.short || '';
};
